import { announcementsFetchReducer } from 'src/modules/announcements/reducers/announcementsFetchReducer';
import { announcementsReadReducer } from 'src/modules/announcements/reducers/announcementsReadReducer';
import { AnnouncementsState } from 'src/modules/announcements/types/AnnouncementsState';
import { chainReducers } from 'src/utils/chainReducers';

const defaultState: AnnouncementsState = {
  announcements: [],
};

export const announcementsReducer = chainReducers(defaultState, [
  announcementsFetchReducer,
  announcementsReadReducer,
]);
